import { createFileRoute } from "@tanstack/react-router";
import { SignIn } from "@/components/auth/signin";
import { validateAuthSearch } from "@/lib/auth";

export const Route = createFileRoute("/signup")({
  validateSearch: validateAuthSearch,
  component: SignUpPage,
});

function SignUpPage() {
  const { return_to } = Route.useSearch();
  return <SignIn mode="signup" returnTo={return_to} />;
}
